import { lazy } from 'react'

export const ProfileSummary = lazy(() => import('./v1/ProfileSummary'))
export const ProfileSummaryV2 = lazy(() => import('./v2/ProfileSummaryV2'))
export const ProfileSummaryV3 = lazy(() => import('./v3/ProfileSummaryV3'))
